import gql from "graphql-tag";

export const GET_SETTINGS = gql`
  query getSettings($name: String!) {
    getSettings(name: $name) {
      _id
      name
      settings
    }
  }
`;

export const GET_ME = gql`
  query me {
    me {
      clientId
      clientName
      password
    }
  }
`;

export const GET_CLIENT = gql`
  query getClient($name: String!) {
    getClient(name: $name) {
      _id
      name
      appName
      openAISystemMessage
      storeSignup
      adminUsers {
        _id
        fullName
        email
        status
      }
      tutorials {
        _id
        page
        title
        videoURL
        description
        allowedSkips
      }
      lessons {
        _id
        title
        age
        lessonNumber
        videoLink
        activities
      }
      courses {
        _id
        title
        age
        description
        imageLink
        groups
        lessons {
          _id
          title
          age
          lessonNumber
          videoLink
          activities
        }
      }
      meditations {
        _id
        title
        age
        description
        audioLink
      }
      movements {
        _id
        title
        age
        description
        videoLink
      }
      visualizations {
        _id
        title
        age
        description
        audioLink
      }
      challenges {
        _id
        published
        title
        description
        difficulty
        duration
        commitment
        imageLink
        startDate
        communityId
        adminCommunityId
        type
        welcomeItem {
          title
          description
          videoLink
          lessonText
          activities
          habits {
            _id
            title
            type
            description
            options
          }
          communityPostText
          communityPostImage
          adminCommunityPostText
          adminCommunityPostImage
        }
        endingItem {
          title
          description
          videoLink
          lessonText
        }
        schedule {
          title
          description
          videoLink
          lessonText
          activities
          habits {
            _id
            title
            type
            description
            options
          }
          startDay
          endDay
          notifications {
            title
            message
            time
          }
          community
          adminCommunity
          notificationTitle
          notificationMessage
          communityPostText
          communityPostImage
          adminCommunityPostText
          adminCommunityPostImage
        }
      }
      habits {
        _id
        title
        type
        description
        options
      }
      resourceFolders {
        _id
        name
        type
        resources {
          _id
          name
          type
          link
          uploadDate
        }
      }
      notifications {
        _id
        title
        message
        frequency
        time
        date
        filters {
          isCoach
          challengeId
        }
      }
    }
  }
`;

export const GET_CLIENTS = gql`
  query getClients {
    getClients {
      _id
      name
      appName
      openAISystemMessage
      storeSignup
      vibeonixApiKey
      webhookApiKey
      androidPackageName
      googleServiceEmail
      googleServicePrivateKey
      appleSharedSecret
      stripeApiKey
      stripeApiKeyDev
      appStoreURL
      playStoreURL
      adminUsers {
        _id
        fullName
        email
        status
      }
      tutorials {
        _id
        page
        title
        videoURL
        description
        allowedSkips
      }
      lessons {
        _id
        title
        age
        lessonNumber
        videoLink
        activities
      }
      courses {
        _id
        title
        age
        description
        imageLink
        groups
        lessons {
          _id
          title
          age
          lessonNumber
          videoLink
          activities
        }
      }
      meditations {
        _id
        title
        age
        description
        audioLink
      }
      movements {
        _id
        title
        age
        description
        videoLink
      }
      visualizations {
        _id
        title
        age
        description
        audioLink
      }
      challenges {
        _id
        published
        title
        description
        difficulty
        duration
        commitment
        imageLink
        startDate
        communityId
        adminCommunityId
        type
        welcomeItem {
          title
          description
          videoLink
          lessonText
          activities
          habits {
            _id
            title
            type
            description
            options
          }
          communityPostText
          communityPostImage
          adminCommunityPostText
          adminCommunityPostImage
        }
        endingItem {
          title
          description
          videoLink
          lessonText
        }
        schedule {
          title
          description
          videoLink
          lessonText
          activities
          habits {
            _id
            title
            type
            description
            options
          }
          startDay
          endDay
          notificationTitle
          notificationMessage
          communityPostText
          communityPostImage
          adminCommunityPostText
          adminCommunityPostImage
        }
      }
      habits {
        _id
        title
        type
        description
        options
      }
      resourceFolders {
        _id
        name
        type
        resources {
          _id
          name
          type
          link
          uploadDate
        }
      }
      notifications {
        _id
        title
        message
        frequency
        time
        date
        filters {
          isCoach
          challengeId
        }
      }
    }
  }
`;

export const GET_APP_USERS = gql`
  query getAppUsers($name: String!) {
    getAppUsers(name: $name) {
      _id
      firstname
      lastname
      email
      active
      type
      createdAt
      subscriptions
      subscription
      isSubscribed
      isCoach
      supportPasswordEnabled
      teamLeader {
        _id
        email
        firstname
        lastname
      }
      isUnofficalMember
      teamMembers {
        _id
        email
        firstname
        lastname
      }
      referredBy {
        _id
        email
        firstname
        lastname
      }
      activeChallenge {
        _id
        challengeId
        title
        imageLink
        duration
        difficulty
        commitment
        description
        communityId
        adminCommunityId
        currentDay
        startDate
      }
      activeCourseId
      rewireChatDates
      dailyStreakDate
    }
  }
`;

export const CHECK_COUPON = gql`
  query checkCoupon($code: String!) {
    checkCoupon(code: $code) {
      name
      code
      amountOff
      percentOff
    }
  }
`;

export const VERIFY_CODE = gql`
  query verifyCode($code: String!) {
    verifyCode(code: $code)
  }
`;
